import { Box, Button, CloseButton, Drawer, Group, LoadingOverlay, Overlay, Stack, Text, TextInput } from "@mantine/core";
import useExternalApiService from "helpers/ExternalApiService";
import { presetKeywordsForLeadSearch } from "helpers/lead";
import { FC, useEffect, useState } from "react";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSearch: (searchTerm: string) => void;
};

interface Keyword {
  id?: number;
  keyword: string;
}

const baseKeywords = presetKeywordsForLeadSearch.map<Keyword>(({label}) => ({
  keyword: label,
}));

const API_URL = process.env.REACT_APP_EAI_URL

const SearchModal: FC<Props> = ({
  isOpen,
  onClose,
  onSearch,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [keywords, setKeywords] = useState<Keyword[]>();
  const [isKeywordsLoading, setIsKeywordsLoading] = useState(true);
  const { postData, getData, deleteData } = useExternalApiService(API_URL);

  const createKeyword = (keyword: string) => {
    setIsKeywordsLoading(true);
    postData("/api/keywords", {
      keyword: keyword,
    })
      .then(() => {
        getData("/api/keywords")
          .then((response) => {
            setKeywords([
              ...(response?.keywords),
              ...baseKeywords,
            ]);
          })
          .finally(() => setIsKeywordsLoading(false));
      })
      .catch(() => setIsKeywordsLoading(false));
  };

  const deleteKeyword = (keywordId: number) => {
    setIsKeywordsLoading(true);
    deleteData(`/api/keywords/${keywordId}`)
      .then(() => {
        setSearchTerm("");
        getData("/api/keywords")
          .then((response) => {
            setKeywords([
              ...(response?.keywords),
              ...baseKeywords,
            ]);
          })
          .finally(() => setIsKeywordsLoading(false));
      })
      .catch(() => setIsKeywordsLoading(false));
  };

  useEffect(() => {
    getData("/api/keywords")
      .then((response) => {
        setKeywords([
          ...(response?.keywords),
          ...baseKeywords,
        ]);
      })
      .finally(() => setIsKeywordsLoading(false));
  }, []);

  return (
    <Drawer
      opened={isOpen}
      zIndex={5001}
      size="xl"
      radius="30px 30px 0 0"
      onClose={() => {
        onClose();
      }}
      position="bottom"
      styles={{
        header: {
          display: "none"
        },
        body: {
          height: "100%",
          boxSizing: "border-box"
        }
      }}
    >
      <Box
        p={0}
        pt={40}
        w="100%"
        h="100%"
        pos="relative"
        style={{
          boxSizing: "border-box"
        }}>
        <Box
          c="#4F7D9C"
          fz="h3"
          fw="bold"
          pos="absolute"
          top={20}
          left={10}>
          Leads Search in Map
        </Box>
        <CloseButton
          size="xl"
          pos="absolute"
          top={10}
          right={-10}
          onClick={() => {
            onClose();
          }}
        />
        <Box pt="xl" style={{ position: "relative", boxSizing: "border-box", height: "100%" }}>
          <Stack justify="space-between" h="95%">
            <Box>
              <Group justify="space-between" align="center" gap={10}>
                <TextInput
                  w="70%"
                  placeholder="Type new keyword"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <Button
                  bg="#4F7D9C"
                  style={{ boxSizing: "border-box" }}
                  onClick={() => createKeyword(searchTerm)}>
                  Add
                </Button>
              </Group>
              <Box h={350} mt={10}
                style={{
                  overflowY: "scroll"
                }}>
                <LoadingOverlay
                  visible={isKeywordsLoading}
                  zIndex={1000} />
                {keywords?.map((k, index) => (
                  <Group align="center" mt={5} py={5} key={index} justify="space-between"
                    style={{
                      borderBottom: "1px solid #F0F0F0"
                    }}>
                    <Group gap="sm" align="center">
                      <input
                        type="radio"
                        value={k.keyword}
                        checked={k.keyword === searchTerm}
                        style={{
                          transform: "scale(1.6)",
                          marginTop: "-2px",
                        }}
                        onChange={(e) => setSearchTerm(e.target.value)} />
                      <Text fz="h4" fw="bold" truncate="end">
                        {k.keyword}
                      </Text>
                    </Group>
                    {k.id && (
                      <Button size="compact-xs" bg="#E64B37"
                        //NOTE: even though k.id is not undefined here compiler/linter
                        // was complaining
                        onClick={() => k.id && deleteKeyword(k.id)}>
                        DELETE
                      </Button>
                    )}
                  </Group>
                ))}
              </Box>
            </Box>
            <Stack align="center" gap="20px">
              <Text fz="12px" maw="290px">
                Saved search keywords will show search location results from Google maps.
              </Text>
              <Text fz="12px" maw="290px" mb="20px">
                This is similar to going to Google Maps and type in the search keyword.
              </Text>
              <Button
                bg="#4F7D9C"
                fullWidth
                style={{ boxSizing: "border-box" }}
                onClick={() => {
                  onSearch(searchTerm);
                }}>
                SEACH FOR LEADS IN MAP
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Box>
    </Drawer>
  );
};

export default SearchModal;

/*
  {
        'handler': request_delete_keyword,
        'uri': '/api/keywords/<keyword-id>',
        'methods': ['DELETE'],
        'permission': 'Modules'
    },
    {
        'handler': request_create_keyword,
        'uri': '/api/keywords',
        'methods': ['POST', 'OPTIONS'],
        'permission': 'Modules'
    },
    {
        'handler': request_get_keywords,
        'uri': '/api/keywords',
        'methods': ['GET'],
        'permission': 'Modules'
}
*/